// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".answer-cell[data-v-59a92658]{overflow-x:auto}", ""]);
// Exports
module.exports = exports;
